import useEntrepreneurRepository from "../../../../../repository/user/useEntrepreneurRepository";
import useCompanyAddressRepository from "../../../../../repository/user/useCompanyAddressRepository";
import useSecurity from "../../../../../use/useSecurity";
import useOrderAddressRepository from "../../../../../repository/emergency/useOrderAddressRepository";
import {useEffect} from "react";
import isNull from "../../../../../mixin/isNull";
import Box from "@mui/material/Box";
import {CircularProgress} from "@mui/material";

export default function ({orderId}) {
    const security = useSecurity();
    const entrepreneurRepository = useEntrepreneurRepository();
    const companyAddressRepository = useCompanyAddressRepository();
    const orderAddressRepository = useOrderAddressRepository();
    /** @type OrderAddress */
    const orderAddress = orderAddressRepository.findOneByOrderId(orderId).select();
    /** @type Entrepreneur */
    const entrepreneur = entrepreneurRepository.findOneById(security.id).select();
    /** @type CompanyAddress */
    const companyAddress = companyAddressRepository.findOneByCompanyId(entrepreneur?.getCompanyId()).select();

    useEffect(() => {
        entrepreneurRepository.findOneById(security.id).exec();
    }, []);

    useEffect(() => {
        if (isNull(entrepreneur)) return;

        companyAddressRepository.findOneByCompanyId(entrepreneur.getCompanyId()).exec();
    }, [JSON.stringify(entrepreneur)]);

    if (isNull(companyAddress) || isNull(orderAddress)) {
        return (
            <Box display="flex" justifyContent={"center"} mt={5}>
                <CircularProgress/>
            </Box>
        )
    }

    return (
        <div>
            <iframe
                width="100%"
                height="400"
                frameBorder="0"
                style={{border: "none"}}
                referrerPolicy="no-referrer-when-downgrade"
                src={`${process.env.REACT_APP_GOOGLE_MAP_URL}?key=${process.env.REACT_APP_GOOGLE_MAP_KEY}&origin=${companyAddress.getPostcode() + "+" + companyAddress.getCity()}&destination=${orderAddress.getPostcode() + "+" + orderAddress.getCity()}&mode=driving&language=fr`}
                allowFullScreen>
            </iframe>
        </div>
    )
}